module.exports = __webpack_public_path__ + "img/d201307-3.ad5878e7.jpg";